import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {ClientReportsContent} from "./ClientReportsContent";
import {withRouterParams} from "../../utils/withRouterParams";

export class ClientReports extends Component {
    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <ClientReportsContent clientId={this.props.match.params.id}/>
            </div>
        )
    }
}

export default withRouterParams(ClientReports);
